import {
  Cpu,
  Users,
  Compass,
  Microscope,
  Database,
  CheckCircle2,
  Server,
  PanelsTopLeft,
  type LucideIcon,
} from 'lucide-react';
import { personaBySlug, type PersonaSlug } from '@/lib/personas';
import { cn } from '@/lib/utils';

const ICON_MAP: Record<string, LucideIcon> = {
  Cpu,
  Users,
  Compass,
  Microscope,
  Database,
  CheckCircle2,
  Server,
  PanelsTopLeft,
};

export interface PersonaIconProps {
  persona: PersonaSlug;
  size?: number;
  className?: string;
}

export function PersonaIcon({
  persona,
  size = 14,
  className,
}: PersonaIconProps) {
  const Icon = ICON_MAP[personaBySlug[persona].icon] ?? Cpu;
  return (
    <Icon
      size={size}
      strokeWidth={1.75}
      aria-hidden="true"
      className={cn('shrink-0 text-ink-mute', className)}
    />
  );
}

export default PersonaIcon;
